import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { ICouponItem, IOrder, OrderService } from '../../services/order.service';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { CouponService } from 'src/app/shared/services/coupon.service';
import { ValidatorsService } from 'src/app/shared/services/validators.service';
import { IBasePromotionRequest, IPromotions, PromotionService } from '../../services/promotion.service';
import { IProfile, ProfileService } from 'src/app/account/services/profile.service';
import { AuthService } from 'src/app/auth/services/auth.service';
import { AnalyticsService } from 'src/app/shared/services/analytics.service';
import { SettingService } from 'src/app/shared/services/setting.service';
import { TranslationService } from 'src/app/shared/services/translation.service';
export interface IDiscount {
  errorCode: number,
  amount: number,
  name: string
}

@Component({
    selector: 'app-checkout-coupon-form',
    templateUrl: './checkout-coupon-form.component.html',
    styleUrls: ['./checkout-coupon-form.component.scss'],
    standalone: false
})
export class CheckoutCouponFormComponent implements OnInit {
  toggleInput: boolean=false;
  form: FormGroup;
  discountAmount: IDiscount;
  couponError: string=null;
  error: boolean=false;
  discountResponse=false;
  @Input() subtotal: number;
  @Input() total: number;
  @Input() storeId: string;
  @Input() order: IOrder;
  @Output() onSubmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeModal: EventEmitter<boolean>=new EventEmitter<boolean>();

  patternReference: any = {};

  promotions: IPromotions[] = [];
  
  promotionRequest: IBasePromotionRequest;

  memberProfile: IProfile;

  constructor(private fb: FormBuilder,
    private orderService: OrderService,
    private loader: LoaderService,
    private couponService: CouponService,
    private router: Router,
    public validators: ValidatorsService,
    public promoService: PromotionService,
    private profile: ProfileService,
    private auth: AuthService,
    private analytics: AnalyticsService,
    private settingService: SettingService,
    private translationService: TranslationService
    ) { }

  ngOnInit() {

    this.discountAmount={
      errorCode: null,
     amount: null,
      name: null
    }
    /*
    this.form = this.fb.group({
      'couponNumber': ['', this.validators.formBuilderValidationInitializer(true)]
    });
    */
    this.form = this.fb.group({
      couponNumber: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true)
      })
    });

    /*
    this.form["patternReference"] = {
      couponNumber: null
    };
    */
    this.patternReference = {
      couponNumber: null
    };

    //this.validators.trackInputChange(this.form);
    this.validators.trackInputChange(this.form, this.patternReference);

    if(localStorage['Coupon']) {
      this.applyCoupon();
    }

    this.getProfile();
    this.getAllPromotions();
    
    

    

    
  }

  applyCoupon()
  {
    this.toggleInput=!this.toggleInput;
  }
  viewOffers()
  {
    this.closeModal.emit(true);
    this.router.navigateByUrl('/account/offers');

  }
  async couponDiscount() {
    this.discountResponse=false;
    this.error=false;
    
    const loader = await this.loader.create();
    await loader.present();

    var isPromotionalCode = this.validatePromotionCode();

    if(isPromotionalCode) {
      // i also need to add possible rejection on the API for the promotion


      //console.log(this.order);
      // the order time in the "this.order" are "this.order._deliveryType" and for each item there's a "this.order.orderItems[0].orderType"

      
      //console.log(this.memberProfile);

      //i have to find the ID of the user first
      var visitorId = "";
      if(this.auth.isAuthenticated){
        if(!localStorage.getItem('visitorId')) {
          await this.analytics.setVisitorId();
          visitorId = localStorage.getItem('visitorId');
        } else {
          visitorId = localStorage.getItem('visitorId');
        }
      }
      

      this.orderService.validatePromotionDiscount({
        merchantId: this.settingService.configuration.merchantId,
        storeId: this.storeId,
        language: this.translationService.getLanguage(),
        promotionCode: this.form.get('couponNumber').value,
        subTotalAmount: this.subtotal,
        totalAmount: this.total,
        orderType: this.order._deliveryType,
        //accountId: this.memberProfile?.Id ?? 0,
        accountId: (this.memberProfile && this.memberProfile.Id) ? this.memberProfile.Id : 0,
        isMember: this.auth.isAuthenticated,
        orderContent: this.order,
        visitorId: visitorId
      })
        .pipe(finalize(async () => {
          this.discountResponse=true;
          await loader.dismiss();
        }))
        .subscribe((data) => {
          if(data)
          {

            //console.log(data);
            
            if (data.error) {
              this.error = true;
              this.discountAmount.amount = 0;
              this.couponError = this.translationService.translate("General.InvalidPromo");
            } else {
              this.discountAmount.amount = data.discountAmount ? data.discountAmount : null;  
              //this.discountAmount.name = data.name ? data.name : null;
              this.discountAmount.errorCode = data.error;


              if(localStorage['Coupon']) {
                localStorage.removeItem('Coupon');
              }

              // update local storage
              /*
              localStorage.setItem('coupons', 
                JSON.stringify(this.couponService.processCouponAvailability()));
              */

              this.promoService.setDiscounts = {
                type: this.order._deliveryType,
                discountNumber: this.discountAmount.amount
              }

              this.promoService.setDiscountsOptions = {
                type: "afterTax",
                discountOption: data.applyAfterTax
              }

              this.promoService.setDiscountsOptions = {
                type: "applyOnItem",
                discountOption: data.applyOnItem
              }

              this.promoService.setDiscountsOptions = {
                type: "itemDiscountedID",
                discountOption: data.discountedItemId
              }

              this.promoService.setDiscountsOptions = {
                type: "applyOnDeliveryFee",
                discountOption: data.applyDeliveryFee
              }
              
              //console.log(this.promoService.getDiscounts);

              this.onSubmit.emit({
                amount: this.discountAmount.amount,
                couponNumber: null,
                promotionNumber: this.form.get('couponNumber').value,
                discountTarget: "deliveryfee", // could be "order", "item", "deliveryfee"
                discountAftertax: false
              });

              // remove the coupon code
              this.form.get('couponNumber').setValue('');
              
            }

            
            
                     
            
          }
  
          },
          (error: HttpErrorResponse) => {
            let keys = Object.keys(error.error.errors);
            this.error=true;
            this.couponError=error.error.errors[keys[0]][0];
          });
      


    } else {
      let couponItems: ICouponItem[] = [];

      for(let i = 0; i < this.order.orderItems.length; i++) {
        couponItems.push({
            price: this.order.orderItems[i].quantity * this.order.orderItems[i].price,
            qty: this.order.orderItems[i].quantity,
            unitPrice: this.order.orderItems[i].price,
            upc: this.order.orderItems[i].itemNumber
        });

        for (let j = 0; j < this.order.orderItems[i].options.length; j++) {
          if (this.order.orderItems[i].options[j].itemId != undefined) {
            if (this.order.orderItems[i].options[j].quantity > 0) {
              couponItems.push({
                price: this.order.orderItems[i].options[j].quantity * this.order.orderItems[i].options[j].price,
                qty: this.order.orderItems[i].options[j].quantity,
                unitPrice: this.order.orderItems[i].options[j].price,
                upc: this.order.orderItems[i].options[j].itemNumber
              });
            }         
          }
        }


      }

      this.orderService.validateECouponsDiscount({
        totalAmount: this.total,
        amount: this.subtotal,
        hardwareInfo: this.form.get('couponNumber').value,
        language: this.translationService.getLanguage(),
        storeId: this.storeId,
        items: couponItems
      })
        .pipe(finalize(async () => {
          this.discountResponse=true;
          await loader.dismiss();

        }))
        .subscribe((data) => {
          if(data)
          {
            if (data.errorCode > 0) {
              this.error = true;
              this.discountAmount.amount = 0;
              this.couponError = this.translationService.translate("General.InvalidPromo");
            } else {
              this.discountAmount.amount=data.discountAmount ? data.discountAmount : null;  
              this.discountAmount.name=data.name ? data.name : null;
              this.discountAmount.errorCode=data.errorCode;
              // update local storage
              localStorage.setItem('coupons', 
                JSON.stringify(this.couponService.processCouponAvailability()));
              
            }

            this.onSubmit.emit({
              amount: this.discountAmount.amount,
              couponNumber: this.form.get('couponNumber').value
            });
            
          }
  
          },
          (error: HttpErrorResponse) => {
            let keys = Object.keys(error.error.errors);
            this.error=true;
            this.couponError=error.error.errors[keys[0]][0];
          });
    
    }

    

  }

  submit() {
    //sanitizing
    this.form.setValue(this.validators.multiSanitizerInput(this.form.value));


    if(this.form.valid) {
      this.couponDiscount();
    }

    
    return;
  }

  validatePromotionCode(): boolean{
    for(var i = 0; i < this.promotions.length; i++) {
      if(this.promotions[i].promotionalCode == this.form.get('couponNumber').value) {
        return true;
        //break;
      }
    }

    return false;
  }

  // getting promotions details
  getAllPromotions(){
    this.fetchPromotions().subscribe(async promotions => {
      this.promotions = [];

      this.promotions = promotions;
      
      /*
      for(var i = 0; i < promotions.length; i++){
        // inject the image URL in each promotions
        this.promotions[i].visualConfig['imgURL'] = await this.promoService.fetchImage(promotions[i].visualConfig.imgShortName);
      }
      */

      console.log(promotions);

      if(localStorage['Coupon'])
      {
        
        this.form.get('couponNumber').setValue(localStorage['Coupon']);
        
        this.submit();

        //trigger the form when a coupon is present
      /* if (this.form.get('couponNumber').value) {
          this.submit();
        }*/
        
      }
    });
  }

  fetchPromotions() {
    this.promotionRequest = {
      merchantId: this.settingService.getMerchantId(),
    }

    return this.promoService.getPromotions(this.promotionRequest);
  }

  // only getting member profile information.
  getProfile() {
    // get the profile.
    this.profile.getProfile()
      .subscribe((profile) => {
       this.memberProfile = profile;
       console.log(profile);
      },
        () => {

        });
  }
}
